export class Appointment {

    date: Date

    id: string

    artistId: string

    customer_id: String

    services: number[]

    createdAt: string

    constructor(date: Date, id: string, customerId: string, artistId: string, services: number[]) {
        this.date = date
        this.id = id
        this.artistId = artistId
        this.customer_id = customerId
        this.services = services
        this.createdAt = new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString()
    }

}